import React from "react";
import { Title, Wrapper } from "./styles";
import { IconType } from "react-icons";

type CardProps = {
  Icon: IconType;
  title: string;
};

function CharacteristicCard({ Icon, title }: CardProps) {
  return (
    <Wrapper>
      <Icon />
      <Title>{title}</Title>
    </Wrapper>
  );
}

export default CharacteristicCard;
